function setCookie(name, value) {
  document.cookie =
    encodeURIComponent(name) + "=" + encodeURIComponent(value) + "; path=/";
}

function getCookie(name) {
  cookies = document.cookie.split("; ");
  for (const cookie of cookies) {
    const [cookieName, cookieValue] = cookie.split("=");
    if (decodeURIComponent(cookieName) === name) {
      return decodeURIComponent(cookieValue);
    }
  }
}

function appendToCookie(name, newValue, type) {
  let delimiter = "__";
  let existingValue = getCookie(name);
  if (existingValue) {
    if (type == "checkedValue") {
      const values = existingValue.split(delimiter);
      existingValue += delimiter + newValue;
      console.log("existingValue",existingValue)
      if (values.length >= 1) {
        location.href = `/pages/compare/products=${existingValue}`;
      }
    } else {
      const values = existingValue.split(delimiter);
      const index = values.indexOf(newValue);
      if (index !== -1) {
        values.splice(index, 1);
        existingValue = values.join(delimiter);
      }
    }
  } else {
    existingValue = newValue;
  }
  setCookie(name, existingValue);
}
